import React, { useEffect, useState } from 'react'
import moment from 'moment';
import Chart from '../utils/Chart';
import { FaPeopleRobbery } from "react-icons/fa6";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FormControl, Col } from "react-bootstrap";
import { PiHandPeace } from "react-icons/pi";
import { FaHeart } from "react-icons/fa";
import { FaHeartCircleExclamation } from "react-icons/fa6";
import Button from '@mui/material/Button';
import Header from "../utils/Header";
import Paper from '@mui/material/Paper';


const DashboardPage = ({ user, supabase, session, handleLogout }) => {
    const [totalNumberofFights, setTotalNumberOfFights] = useState(0);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [numberOfFightDays, setNumberOfFightDays] = useState(0);
    const [relationshipHealth, setRelationshipHealth] = useState(0);
    const [days, setDays] = useState([]);
    // const [otherPeoplesFights, setOtherPeoplesFights] = useState(0);

    useEffect(()=>{
        setStartDate(moment().subtract(30, 'day').format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        get_all_fights(moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD'));
        get_other_peoples_fight(moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD'));
   
    },[])

    const get_all_fights = async(begin, end) =>{
       const { data, error } =
           await supabase
            .from('fights')
            .select()
            .gte('start_date', begin)
            .lte('start_date', end)
             .eq("user_id", session.user.id);
            if(data?.length > 0){
                setTotalNumberOfFights(data.length);
                setNumberOfFightDays(new Set(data.map((el)=> el.start_date)).size);
                // get unique start date and just use size'
                let temp_days = {
                    Monday: 0,
                    Tuesday: 0,
                    Wednesday: 0,
                    Thursday: 0,
                    Friday: 0,
                    Saturday: 0,
                    Sunday: 0,
                }
                
               let temp = []
               data.map((el)=>{ 
                    temp_days[moment(el.start_date).format("dddd")] = temp_days[moment(el.start_date).format("dddd")] + 1
                 });
                 
               Object.keys(temp_days).forEach((key)=>{
                temp.push({
                    name: key,
                    number_of_fights: temp_days[key]
                })
               })
               setDays([...temp]);
            } else {
                setTotalNumberOfFights(0);
                setNumberOfFightDays(0);
                setDays([]);
            }
    }

    // need fight count per user for time period, need to speak to ward about this, might need a cte table
       const get_other_peoples_fight = async(begin, end) =>{
    //    const { data, error } =
    //        await supabase
    //         .from('fights')
    //         .select(`start_date`)
    //         .gte('start_date', begin)
    //         .lte('start_date', end)
    //          .neq("user", session.user.id);
    //         if(data?.length > 0){
    //             setOtherPeoplesFights(data.length);
    //         } else {
    //            setOtherPeoplesFights(0);
    //         }
    }

      


  return (
    <div style={{ fontFamily:"lato", margin:"10px"}}>
        <Header session={session} handleLogout={handleLogout} />
               <div>
                <Paper elevation={3} style={{display:"flex", justifyContent:"center", alignContent:"center", alignItems:"center", flexDirection:"column", padding:"10px"}}>
                        <Col xs={5}>
                            <FormControl 
                                type="date" 
                                value={startDate}
                                onChange={(e)=> setStartDate(moment(e.target.value).format('YYYY-MM-DD')) } 
                                required
                            />
                        </Col>
                        <Col xs={2}>
                            to
                        </Col>
                            <Col xs={5}>
                            <FormControl 
                                type="date" 
                                value={endDate}  
                                onChange={(e)=> setEndDate(moment(e.target.value).format('YYYY-MM-DD')) } 
                                required

                            />
                            </Col>
                            <Button  variant="contained" style={{backgroundColor:"#dc3545", marginTop:"10px"}} onClick={()=>{ get_all_fights(startDate, endDate); get_other_peoples_fight(startDate, endDate)}}>Submit</Button>
                </Paper>
                <div style={{display:"flex", textAlign:"center", width:"100%", justifyContent:"center"}}>
                    <h1>
                        ~  {Math.abs(moment(startDate).diff(endDate,'days'))} days
                    </h1>
                </div>
            </div>
        <div style={{backgroundColor:"#faf8f8", display:"flex", padding:"10px", flexWrap:"wrap", justifyContent:"space-evenly", gap:"10px"}}>
            <div style={{padding:"12px", backgroundColor:"#f2f2fc", minWidth:"200px", flexGrow:2}}>
                <div style={{display:"flex", justifyContent:"space-between"}}>
                    <div>Total Fights</div>
                    <div><FaPeopleRobbery /></div>
                </div>
                <h1> {totalNumberofFights}</h1>
            </div>
              <div style={{padding:"12px", backgroundColor:"#f2f2fc", minWidth:"200px", flexGrow:2}}>
                <div style={{display:"flex", justifyContent:"space-between"}}>
                    <div>Incident Days</div>
                    <div><FaRegCalendarAlt /></div>
                </div>
                
                <h1> {numberOfFightDays} </h1>
            </div>
             <div style={{padding:"12px", backgroundColor:"#f2f2fc", minWidth:"200px", flexGrow:2}}>
                <div style={{display:"flex", justifyContent:"space-between"}}>
                    <div>Peacefull Days</div>
                    <div><PiHandPeace /></div>
                </div>
                <h1> {Math.abs(numberOfFightDays - Math.abs(moment(startDate).diff(endDate,'days'))) }</h1>
            </div>
             <div style={{padding:"12px", backgroundColor:"#f2f2fc", minWidth:"200px", flexGrow:2}}>
                <div style={{display:"flex", justifyContent:"space-between"}}>
                    <div>Relationship Health</div>
                    <div>{relationshipHealth <= 40 ? <FaHeartCircleExclamation style={{color:"#c6a80b"}} /> : <FaHeart  style={{color:"darkgreen"}}/>}</div>
                </div>
                <h1> {(Math.abs(numberOfFightDays - Math.abs(moment(startDate).diff(endDate,'days'))) /  Math.abs(moment(startDate).diff(endDate,'days'))*100 ).toFixed(2)}%</h1>
            </div>
        </div>
        <div style={{height: "200px", backgroundColor:"#faf8f8",}}>
            <Chart 
            data ={
                    {
                        labels: days.map((el)=>{return el.name}),
                        datasets: [
                        {
                            label: 'fight',
                            data: days.map((el)=>{return el.number_of_fights}),
                            backgroundColor: '#c3c3fb',
                            maxBarThickness:10
                        },

                        ],
                    }
                }
            />

        </div>
         
     {/* <div style={{display:"flex", justifyContent:"space-around"}}>
            number of fights: {totalNumberofFights} <br />
            number of fight days: {numberOfFightDays} <br />
            number of days between selected Days: {Math.abs(moment(startDate).diff(endDate,'days'))} <br />
            Days of tranquility: {Math.abs(numberOfFightDays - Math.abs(moment(startDate).diff(endDate,'days'))) } <br />
            Percentage of fights:  {(Math.abs(numberOfFightDays / Math.abs(moment(startDate).diff(endDate,'days')))*100).toFixed(2)} <br />
            calmness Indicator: {(Math.abs(numberOfFightDays - Math.abs(moment(startDate).diff(endDate,'days'))) /  Math.abs(moment(startDate).diff(endDate,'days'))*100 ).toFixed(2)}
         
        </div> */}
    </div>
  )
}

export default DashboardPage
